import { MultiSelect, SimpleSelect } from 'corso-admin-ui';
import { Pegasus } from 'corso-types';
import { Controller } from 'react-hook-form';
import { useAutomationFormContext } from '~/features/settings/automations/hooks/useAutomationForm';
import { useFactValues } from '~/features/settings/hooks/useFactValues';

const orderTagActionLabel = {
  [Pegasus.OrderTagActionTarget.Original_Order]: 'Original Order',
  [Pegasus.OrderTagActionTarget.Replacement_Order]: 'Reorder',
} satisfies Record<Pegasus.OrderTagActionTarget, string>;

const orderTagActionOptions = Object.values(Pegasus.OrderTagActionTarget).map(
  (action) => ({ value: action, label: orderTagActionLabel[action] }),
);

export function EventShippingClaimApplyOrderTags() {
  const { control, watch } = useAutomationFormContext();
  const { data: factValues } = useFactValues();

  const tagOptions = factValues?.arbitrary['order/tags'];
  const selectedAction = watch('event.params.orderTagAction');

  return (
    <>
      <Controller
        control={control}
        name="event.params.orderTagAction"
        render={({ field, fieldState }) => (
          <SimpleSelect
            label="Which order would you like to tag?"
            details={
              selectedAction === 'Original Order'
                ? 'The original order that the shipping claim was filed against will be tagged.'
                : 'The reorder that was created to resolve the shipping claim will be tagged.'
            }
            placeholder="Select Order"
            options={orderTagActionOptions}
            onChange={field.onChange}
            value={field.value}
            error={fieldState.error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name="event.params.orderTags"
        render={({ field, fieldState }) => (
          <MultiSelect
            label="Order Tags"
            options={(tagOptions ?? []).map((tag) => ({
              label: tag,
              value: tag,
            }))}
            details="The tags to apply."
            placeholder="Add tags"
            value={field.value.map(({ name }) => ({
              label: name,
              value: name,
            }))}
            onChange={(selections) =>
              field.onChange(selections.map(({ value }) => ({ name: value })))
            }
            error={fieldState.error?.message}
            creatable
          />
        )}
      />
    </>
  );
}
